(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["file-icons"] = factory(require("react"));
	else
		root["file-icons"] = factory(root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__16__) {
return 